import { useState } from "react";
import { toast } from "sonner";
import { Input } from "@/components/ui/input";
import { Checkbox } from "@/components/ui/checkbox";
import { api, errMsg } from "@/lib/api";

export const GENDERS = [
  ["male", "Male"],
  ["female", "Female"],
  ["non_binary", "Non-binary"],
  ["self_describe", "Prefer to self-describe"],
  ["prefer_not_to_say", "Prefer not to say"],
];

export const GenderFields = ({ value, setValue }) => (
  <div className="space-y-3">
    <div role="radiogroup" aria-label="What is your gender?" className="grid sm:grid-cols-2 gap-2">
      {GENDERS.map(([id, label]) => (
        <button key={id} type="button" role="radio" aria-checked={value.gender === id} data-testid={`gender-option-${id}`}
          onClick={() => setValue({ ...value, gender: id })}
          className={`rounded-2xl border px-4 py-3.5 text-left text-sm font-medium transition-colors ${value.gender === id ? "border-primary bg-primary/10" : "border-border hover:border-primary/40"}`}>
          {label}
        </button>
      ))}
    </div>
    {value.gender === "self_describe" && (
      <Input data-testid="gender-self-describe-input" value={value.self_description} maxLength={60}
        onChange={(e) => setValue({ ...value, self_description: e.target.value })} placeholder="How do you describe yourself? (optional)" className="h-12 rounded-xl" />
    )}
    {value.gender && value.gender !== "prefer_not_to_say" && (
      <label className="flex items-start gap-3 rounded-2xl border border-border p-4 text-sm cursor-pointer">
        <Checkbox data-testid="gender-store-checkbox" checked={value.store} onCheckedChange={(c) => setValue({ ...value, store: !!c })} className="mt-0.5" />
        <span>I agree to save this answer privately on my profile to personalise suggested replies. <span className="text-muted-foreground">Leave unchecked to continue without saving it.</span></span>
      </label>
    )}
  </div>
);

export const GenderStep = ({ onDone }) => {
  const [value, setValue] = useState({ gender: null, self_description: "", store: false });
  const [busy, setBusy] = useState(false);
  const submit = async () => {
    setBusy(true);
    try {
      const { data } = await api.post("/onboarding/gender", value);
      onDone(data);
    } catch (e) {
      toast.error(errMsg(e));
    } finally {
      setBusy(false);
    }
  };
  return (
    <section className="panel p-6 sm:p-8 space-y-6 rise" data-testid="gender-step">
      <div className="space-y-2">
        <h1 className="text-3xl font-extrabold tracking-tight">Tell us a little about yourself</h1>
        <p className="text-sm text-muted-foreground">This helps us personalize suggested replies and improve your experience. It's private, never shown publicly, and never affects access or pricing.</p>
      </div>
      <div className="space-y-3">
        <div className="text-base font-semibold">What is your gender?</div>
        <GenderFields value={value} setValue={setValue} />
      </div>
      <button data-testid="gender-continue-button" disabled={!value.gender || busy} onClick={submit}
        className="w-full h-12 rounded-full brand-gradient text-white font-semibold disabled:opacity-40 transition-opacity">
        {busy ? "Saving…" : "Continue"}
      </button>
    </section>
  );
};
